export default function () {
  return {
    countCells: 8,
    massive: [
      {
        dataField: 'kcp',
        cols: 2,
        rows: 1,
        text: '&nbsp;',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end border-bottom-zero',
        headerStyles: `min-width: 305px; min-height: 30px; justify-content: flex-start;`,
        order: 0,
        variable: true,
        template: r => r?.kcpGroup.code + ' ' + r?.kcpGroup.name
      },
      {
        dataField: 'secondCell',
        cols: 2,
        rows: 1,
        text: `Справочно:`,
        class: 'justify-start',
        headerClass: ' align-start border-bottom-zero table-header-info',
        headerStyles: `min-width: 160px`,
        order: 1,
        variable: false,
      },
      {
        dataField: 'pv',
        cols: 2,
        rows: 3,
        order: 2,
        variable: true,
        headerClass: 'align-start ',
        headerStyles: `min-width: 100px`,
        text: `Потребность в&nbsp;подготовке кадров на долгосрочный период`,
        template: r => r?.pv
      },
      // {
      //   dataField: 'fourthCell',
      //   cols: 1,
      //   rows: 2,
      //   order: 3,
      //   variable: false,
      //   class: `justify-center `,
      //   headerClass: 'align-start  border-bottom-zero',
      //   headerStyles: `min-width: 115px`,
      //   text: `Потребность в&nbsp;приеме`,
      // },
      // {
      //   dataField: 'fifthCell',
      //   cols: 1,
      //   rows: 2,
      //   order: 4,
      //   variable: false,
      //   headerClass: 'align-start border-bottom-zero',
      //   headerStyles: ``,
      //   text: 'Доля федерального бюджета в&nbsp;приеме',
      // },
      {
        dataField: '1',
        cols: 2,
        rows: 2,
        order: 5,
        variable: false,
        text: 'Общий объем КЦП на 2024/2025 год',
        headerClass: 'border-bottom-zero',
        headerStyles: `justify-content: center; min-width: 300px; align-items: flex-start`,
      },

      ////////////////////////////////////////////////////// вторая строка хэдера

      {
        dataField: 'kcp1',
        cols: 2,
        rows: 1,
        text: '',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end table-header-info border-bottom-zero',
        headerStyles: `min-width: 305px; justify-content: flex-start;`,
        order: 0,
        variable: true,
        template: r => r?.kcpGroup.code + ' ' + r?.kcpGroup.name
      },
      {
        dataField: '2',
        cols: 2,
        rows: 1,
        order: 5,
        variable: false,
        headerClass: 'text-center border-bottom-zero',
        text: 'КЦП прошлых периодов\n',
        headerStyles: `justify-content: flex-start; min-width: 100px`,
      },
      {
        dataField: '333',
        cols: 2,
        rows: 1,
        order: 0,
        class: 'd-flex flex-row align-center justify-start  ',
        variable: false,
        text: 'УГСН (НПС)',
        headerClass: 'header-table-cell align-end table-header-info',
        headerStyles: `justify-content: flex-start; min-width: 100px`,
      },
      {
        dataField: 'kcp21',
        cols: 1,
        rows: 1,
        order: 7,
        variable: true,
        class: ' ',
        headerClass: 'table-header-info',
        headerStyles: `justify-content: flex-start`,
        text: '2022',
      },
      {
        dataField: 'kcp22',
        cols: 1,
        rows: 1,
        order: 8,
        variable: true,
        class: ' ',
        headerClass: ' table-header-info',
        text: '2023 ',
      },
      // {
      //   dataField: 'pp',
      //   cols: 1,
      //   rows: 1,
      //   order: 10,
      //   variable: true,
      //   class: ``,
      //   headerClass: ' header-table-cell table-header-info',
      //   headerStyles: `padding: 8px 10px 8px 0 !important`,
      //   text: '2024 год',
      // },
      // {
      //   dataField: 'dj',
      //   cols: 1,
      //   rows: 1,
      //   order: 11,
      //   variable: true,
      //   class: ``,
      //   headerClass: ' header-table-cell table-header-info',
      //   headerStyles: `padding: 8px 15px 8px 0 !important`,
      //   text: '2024 год',
      // },
      {
        dataField: 'startValue',
        cols: 1,
        rows: 1,
        order: 12,
        variable: true,
        headerClass: ' header-table-cell table-header-info',
        class: '',
        text: 'Прогноз',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'value',
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell table-header-info',
        styles: 'justify-content: unset;',
        text: 'Субъект РФ',
        headerStyles: `padding: 8px 15px 8px 0 !important; `,
      },
    ],


    rowsMassive: [ // строки таблицы
      {
        dataField: 'kcp',
        cols: 2,
        rows: 1,
        // text: 'УГСН (НПС)',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end ',
        headerStyles: `min-width: 305px; justify-content: flex-start;`,
        order: 0,
        variable: true,
        template: r => r?.kcpGroup.code + ' ' + r?.kcpGroup.name
      },
      {
        dataField: 'kcp22',
        cols: 1,
        rows: 1,
        order: 7,
        variable: true,
        class: ' ',
        headerClass: '',
        headerStyles: `justify-content: flex-start`,
        // text: '2022',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.kcp22, 0)
      },
      {
        dataField: 'kcp23',
        cols: 1,
        rows: 1,
        order: 8,
        variable: true,
        class: ' ',
        headerClass: ' ',
        // text: '2023 ',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.kcp23, 0)
      },
      {
        dataField: 'pv',
        cols: 2,
        rows: 1,
        order: 2,
        variable: true,
        styles: 'justify-content: unset;',
        // text: `Потребность в подготовке кадров на долгосрочный период`,
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.pv, 0)
      },
      // {
      //   dataField: 'pp',
      //   cols: 1,
      //   rows: 1,
      //   order: 10,
      //   variable: true,
      //   class: ``,
      //   styles: 'justify-content: unset;',
      //   template: (r) => this.$scripts.TableJs.formatValueInCell(r.pp, 0)
      // },
      // {
      //   dataField: 'dj',
      //   cols: 1,
      //   rows: 1,
      //   order: 11,
      //   variable: true,
      //   class: ``,
      //   styles: 'justify-content: unset;',
      //   template: r => r?.dj && !Number.isNaN(r?.dj * 100) ? (r?.dj * 100).toFixed(2) + '%' : 'н.д.'
      // },
      {
        dataField: 'startValue',
        cols: 1,
        rows: 1,
        order: 12,
        variable: true,
        headerClass: ' header-table-cell ',
        class: '',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
        styles: 'justify-content: unset;',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.startValue, 0)
      },
      {
        dataField: 'stage2Value',
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell',
        styles: 'justify-content: unset;',
        headerStyles: `padding: 8px 15px 8px 0 !important; `,
      },
    ]
  }
}